import React, { useState, useRef, useEffect } from 'react';
import { allCountries } from 'country-telephone-data';
import './CountryPhoneInput.css';

const FLAG_URL = (iso2) => `https://flagcdn.com/20x15/${iso2.toLowerCase()}.png`;

const getDigitCount = (format, dialCode) => {
  const total = (format || '').replace(/[^.]/g, '').length;
  return total > 0 ? total - (dialCode || '').length : 15;
};

const CountryPhoneInput = ({ value = '', country = 'in', onChange, onBlur, error = false, darkMode = false, placeholder }) => {
  const [selected, setSelected] = useState(
    () => allCountries.find(c => c.iso2 === country.toLowerCase()) || allCountries.find(c => c.iso2 === 'in')
  );
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropRef = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (dropRef.current && !dropRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = allCountries.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) || c.dialCode.includes(search.replace('+', ''))
  );

  const handleCountrySelect = (c) => {
    setSelected(c);
    setOpen(false);
    setSearch('');
    onChange?.('', c);
  };

  const handleNumberChange = (e) => {
    const digits = getDigitCount(selected.format, selected.dialCode);
    const raw = e.target.value.replace(/\D/g, '').slice(0, digits);
    onChange?.(raw, selected);
  };

  const expectedDigits = getDigitCount(selected.format, selected.dialCode);

  return (
    <div className={`cpi-wrap ${darkMode ? 'cpi-dark' : ''} ${error ? 'cpi-error' : ''}`}>
      <div className="cpi-select" ref={dropRef}>
        <button type="button" className="cpi-trigger" onClick={() => setOpen(o => !o)}>
          <img src={FLAG_URL(selected.iso2)} alt={selected.iso2} className="cpi-flag" onError={e => e.target.style.display='none'} />
          <span className="cpi-dial">+{selected.dialCode}</span>
          <span className="cpi-chevron">{open ? '▲' : '▼'}</span>
        </button>
        {open && (
          <div className="cpi-dropdown">
            <input className="cpi-search" placeholder="Search country..." value={search} onChange={e => setSearch(e.target.value)} autoFocus />
            <ul className="cpi-list">
              {filtered.map((c, i) => (
                <li key={`${c.iso2}-${i}`} className={`cpi-item ${c.iso2 === selected.iso2 ? 'cpi-item-active' : ''}`} onClick={() => handleCountrySelect(c)}>
                  <img src={FLAG_URL(c.iso2)} alt={c.iso2} className="cpi-flag" onError={e => e.target.style.display='none'} />
                  <span className="cpi-item-name">{c.name}</span>
                  <span className="cpi-item-dial">+{c.dialCode}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <input
        type="tel"
        className="cpi-input"
        value={value}
        onChange={handleNumberChange}
        onBlur={onBlur}
        placeholder={placeholder || 'Enter mobile number'}
        maxLength={expectedDigits || 15}
      />
    </div>
  );
};

export default CountryPhoneInput;
